import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { initialSampleTypesModalState, IContentSampleTypesGrid, ISampleTypesModalState } from '@/modules/configurationModule/detail/samples/samplesTypes/SampleTypes.models'
import { sampleTypeWorkflowsServices } from '@/api/resources/common/sampleTypeWorkflowsService'

@Component
export default class SampleTypesModal extends Vue {
    @Ref() readonly sampleTypesModal!: any
    @Prop(String) readonly actionTitle!: string
    @Emit()
    update(sampleType: IContentSampleTypesGrid[]): IContentSampleTypesGrid[] {
        return sampleType
    }
    @Emit()
    create(sampleType: IContentSampleTypesGrid) {
        return sampleType
    }

    private state: ISampleTypesModalState
    constructor() {
        super()
        this.state = initialSampleTypesModalState()
    }

    async created() {
        await this.loadWorkflows()
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }

    get modelValidated(): boolean {
        const modelValidated = !!this.state.model.code && !!this.state.model.description && !!this.state.model?.workflow?.code
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors && modelValidated
    }

    async show(selectedRow: IContentSampleTypesGrid): Promise<void> {
        this.state = {
            ...this.state,
            model: {
                ...initialSampleTypesModalState().model
            }
        }
        await this.$validator.reset()
        if (selectedRow) {
            this.state = {
                ...this.state,
                model: { ...selectedRow }
            }
        }
        this.sampleTypesModal.show()
    }

    hide() { this.sampleTypesModal.hide() }

    actionModal() {
        if (this.state?.model?.id) {
            this.update([this.state?.model])
        } else {
            this.create(this.state?.model)
        }
    }

    async loadWorkflows() {
        const [err, data] = await this.$_toCall(sampleTypeWorkflowsServices.getSampleTypeWorkflows())
        if (err) {
            this.state.workflows = []
        }
        this.state.workflows = data
    }
}
